/**
 * Transaction splitting type definitions
 * Types for the transaction splitting functionality
 */

// Individual split item for creating child transactions
export interface SplitItem {
  description: string;
  amount: number;
  glAccountNumber: string;
  glAccountName: string;
  category: string;
  glSubcategory?: string;
}

// Request payload for splitting a transaction
export interface SplitTransactionRequest {
  transactionId: string;
  splits: SplitItem[];
}

// Response from split transaction API
export interface SplitTransactionResponse {
  success: boolean;
  parentTransaction: Transaction;
  childTransactions: Transaction[];
  message?: string;
}

// Extended Transaction interface to include split-related fields
export interface Transaction {
  id: string;
  organizationId?: string;
  userTransactionId: string;
  timestamp: string;
  description: string;
  amount: number;
  type: 'income' | 'expense';
  reconciled: boolean;
  currency: string;
  accountId: string;
  accountName: string;
  accountInstitution?: string;
  glAccountNumber: string;
  glAccountName: string;
  glSubcategory?: string;
  category: string;
  ruleBasedAssignment?: boolean;
  appliedRuleId?: string;
  appliedRuleName?: string;
  aiPredictionConfidence?: number;
  aiPredictionUsed?: boolean;
  status: TransactionStatus;
  reviewedAt?: string;
  reviewedBy?: string;
  
  // Split-related fields
  parentTransactionId?: string;
  splitIndex?: number;
  isSplitChild: boolean;
  
  // Transfer tracking fields (from existing interface)
  isTransfer?: boolean;
  transferId?: string;
  transferPartnerTransactionId?: string;
  transferStatus?: string;
  transferFeeAmount?: number;
  transferFeeCurrency?: string;
  transferDetectedAt?: string;
  transferReviewedAt?: string;
  transferReviewedBy?: string;
  
  // Audit fields
  createdAt: string;
  updatedAt: string;
}

// Transaction status enum including SPLIT status
export enum TransactionStatus {
  UNDER_REVIEW = 'UNDER_REVIEW',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  SPLIT = 'SPLIT'
}

// Transaction type enum
export enum TransactionType {
  INCOME = 'INCOME',
  EXPENSE = 'EXPENSE'
}

// Transfer status for existing transfer functionality
export enum TransferStatus {
  NO_MATCH = 'NO_MATCH',
  UNDER_REVIEW = 'UNDER_REVIEW',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}

// Split validation state for UI
export interface SplitValidationState {
  isValid: boolean;
  totalAmount: number;
  remainingAmount: number;
  errors: string[];
}

// Split modal state management
export interface SplitModalState {
  isOpen: boolean;
  transaction: Transaction | null;
  splits: SplitItem[];
  validation: SplitValidationState;
  isSubmitting: boolean;
}